export default Object.freeze({
    Submit: 0,
    Discard: 1,
    Decline: 2,
});
